import React from 'react';
import {
    ChatAutoComplete,
    useMessageInputContext,
} from 'stream-chat-react';
import '../styles/CustomInput.css';
import { FaIcon } from "../shared/ui";
import { faCircleRight } from "@fortawesome/free-solid-svg-icons";
import SecondaryUserDisabledNotice from './SecondaryUserDisabledNotice';

export const CustomInput = ({ disabled }) => {
    const { text, handleSubmit } = useMessageInputContext();

    const handleSend = (e) => {
        e.preventDefault();
        if (text?.trim()) {
            handleSubmit();
        }
    };

    return (
        <>
            {/* Render the notice above the input */}
            <SecondaryUserDisabledNotice />
            <div className="custom-input-container">
                <ChatAutoComplete className="custom-input-field" disabled={disabled} />
                <button
                    onClick={handleSend}
                    disabled={!text?.trim()}
                    className={`custom-send-button${text?.trim() ? " rotated" : ""}`}
                    aria-label="Send message"
                >
                    <FaIcon icon={faCircleRight} size="xl" />
                </button>
            </div>
        </>
    );
};